var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgStarBlank = function SvgStarBlank(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F69B2C",
    d: "M12,1 L14.9912845,8.83227329 L23,9.40325225 L16.84,14.8148423 L18.7983739,23 L12,18.5122733 L5.20162612,23 L7.16,14.8148423 L1,9.40325225 L9.00871549,8.83227329 L12,1 Z M9.71552282,9.78441993 L3.45695736,10.2306225 L8.27279765,14.4613617 L6.76316618,20.7709697 L12,17.3140432 L17.2368338,20.7709697 L15.7272024,14.4613617 L20.5430426,10.2306225 L14.2844772,9.78441993 L12,3.80282588 L9.71552282,9.78441993 Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStarBlank, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/StarBlank.6de4147a.svg";
export { ForwardRef as ReactComponent };